import React, { useEffect, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Dropzone from "react-dropzone";
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCloudUploadAlt, faInfoCircle, faExclamationCircle, faFlag } from '@fortawesome/free-solid-svg-icons';
import { NavLink, useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import * as XLSX from 'xlsx';
import { clearCookie, getPrivileges } from '../../../functions/Auth';
import API_PATH from "../../../constants/config.json";

import '../../../scss/components/_import_data.scss';
import ImportTemplates from './ImportTemplates';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const ImportPanel = (props) => {

    const theme = useTheme();
    let history = useHistory();
    const [fileNames, setFileNames] = React.useState([]);
    const [getCloudStorage, setCloudStorage] = React.useState(0);
    const [fileListData, setFileListData] = React.useState([]);
    const [getFileStorage, setFileStorage] = React.useState(0);
    const [hoverActive, setHoverActive] = useState(false);
    const [validTypes, setValidTypes] = useState([]);
    const [tabValue, setTabValue] = React.useState(0);

    useEffect(() => {
        if (getPrivileges().length !== 0) {
            getFileList();
            getFileSize();
            getValidVideoFormat();
        }
    }, [])

    const getValidVideoFormat = async () => {
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getValidVideoFormat,
            }).then(async function (response) {
                if(response.status === 200) {
                    let data = response.data.data;
                    let vtypes = data.rows.map( format => format.name);
                    setValidTypes(vtypes);
                } 
            }).catch(async function (error) {
                console.log("error", error)
            })
        } catch (error) {
            console.error(error);
        }
    }

    /* This Function is used for Drag and Drop File start */
    const handleDrop = async (acceptedFiles) => {
        let importStationId = props.importStationId;
        let details = props.details;
        if (importStationId) {
          if (props.tempView) {
            props.tempView.graphics.removeAll();
            props.tempView.zoom = 14;
          }
          props.setSearchChecked(false);
          props.setMidblockChecked(false);
          props.setIntersectionChecked(false);
        }

        let fileData = [];
        // props.setMyIndexValue(null);
        let start = new Date;
        let sleeptime = 500;
        // This Conition check files length
        let remainingArr;
        if ((details.length + acceptedFiles.length) <= API_PATH.fileUploadLimit) {
            remainingArr = acceptedFiles.length;
        } else {
            remainingArr = API_PATH.fileUploadLimit - details.length;
            if ((details.length + acceptedFiles.length) >= API_PATH.fileUploadLimit) {
                sleeptime = 20000;
            }
        }
        
        props.setLoaderShow('block');
        let fileIndex = [];
        for (let j = 0; j < remainingArr; j++) {
            setFileNames([...fileNames, ...acceptedFiles]);
            let reader = new FileReader();
            props.setImportFilesListChecked(true);
            props.handleActiveImportFile(true);
            props.setSearchChecked(false);
            props.setMidblockChecked(false);
            props.setPopuptemplateChecked(false);
            props.setIntersectionChecked(false);
            props.setDetailsPanel(false);
            let fileExe = acceptedFiles[j].name.split('.').pop();
            let droppedFileSize = acceptedFiles[j].size;
            await fileData.push(acceptedFiles[j]);
            var content = '';
            if ( validTypes.includes(fileExe)) {
                await unSucsessData(errorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
            } else {
                if (fileExe === 'prn' || fileExe === 'PRN' || fileExe === 'txt' || fileExe === 'TXT' || fileExe === 'csv' || fileExe === 'CSV' || fileExe === 'xls' || fileExe === 'XLS' || fileExe === 'xlsx' || fileExe === 'XLSX') {
                    if (getCloudStorage > 0) {
                    if (droppedFileSize <= getCloudStorage) {
                        reader.onload = async function (e) {
                        let n = 20;
                        let lines = '';
                        let mGroup;
                        let result = e.target.result;
                        if(fileExe === 'xlsx' || fileExe === 'XLSX') {
                            const wb = XLSX.read(result, {type: 'array'});
                            /* Get first worksheet */
                            const wsname = wb.SheetNames[0];
                            const ws = wb.Sheets[wsname];
                            /* Convert array of arrays */
                            const data = XLSX.utils.sheet_to_csv(ws);
                            result = data;
                        }
                        lines = result.split('\n');
                        for (let line = 0; line < n; line++) {
                            if (lines[line] && lines[line] !== '') {
                            content += lines[line];
                            content += '\n';
                            }
                        }
                        // This code use for match file data using Regex 
                        for (let i = 0; i < fileListData.length; i++) {
                            let patternData = fileListData[i].pattern;
                            let file_type_id = fileListData[i].file_type_id;
                            let vendor = fileListData[i].vendor;
                            if (vendor === null) {
                            vendor = '';
                            }
                            let dataType = fileListData[i].data_type;
                            let stationId;
                            let filename = acceptedFiles[j].name;
                            if (patternData !== null) {
                                try {
                                    patternData = patternData.slice(1, -1);
                                    patternData = new RegExp(patternData);
                                    if (patternData.test(content)) {
                                        mGroup = content.match(patternData);
                                        content = '';
                                        stationId = mGroup[1].trim();
                                        if(stationId.includes("'")) {
                                            stationId = stationId.replaceAll("'","");
                                        }
                                        if (stationId === '' && !importStationId) {
                                            await sucsessData(errorStatus, filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'success');
                                        } else if (stationId === '' && importStationId) {
                                            await sucsessData('Queued', filename, importStationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'success');
                                        } else if (stationId !== '' && importStationId && stationId !== importStationId) {
                                            await sucsessData('Warning', filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'warning');
                                        } else if (stationId !== '' && importStationId && stationId == importStationId) {
                                            await sucsessData('Queued', filename, importStationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'success');
                                        } else {
                                            await sucsessData('Queued', filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'success');
                                        }
                                        break;
                                    } else {
                                        if (i == fileListData.length - 1) {
                                            content = '';
                                            if (importStationId) {
                                            await sucsessData('Queued', acceptedFiles[j].name, importStationId, '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                                            } else {
                                            await unSucsessData(errorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                                            }
                                            break;
                                        }
                                    }
                                } catch (e) {
                                    continue;
                                }
                            } else {
                            if (i == fileListData.length - 1) {
                                content = '';
                                if (importStationId) {
                                await sucsessData('Queued', acceptedFiles[j].name, importStationId, '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                                }
                                else {
                                await unSucsessData(errorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                                }
                                break;
                            } 
                            } 
                        }
                        // This code use for match file data using Regex              
                        };
                        if(fileExe === 'xlsx' || fileExe === 'XLSX')
                            reader.readAsArrayBuffer(fileData[j]);
                        else
                            reader.readAsText(fileData[j], "UTF-8");
                    } else {
                        reader.onload = async function (e) {
                        let n = 20;
                        let lines = '';
                        let mGroup;
                        lines = e.target.result.split('\n');
                        for (let line = 0; line < n; line++) {
                            if (lines[line] && lines[line] !== '') {
                            content += lines[line];
                            content += '\n';
                            }
                        }
                        // This code use for match file data using Regex 
                        for (let i = 0; i < fileListData.length; i++) {
                            let patternData = fileListData[i].pattern;
                            let file_type_id = fileListData[i].file_type_id;
                            let vendor = fileListData[i].vendor;
                            if (vendor === null) {
                            vendor = '';
                            }
                            let dataType = fileListData[i].data_type;
                            let stationId;
                            let filename = acceptedFiles[j].name;
                            if (patternData !== null) {
                            try {
                                patternData = patternData.slice(1, -1);
                                patternData = new RegExp(patternData);
                                if (patternData.test(content)) {
                                mGroup = content.match(patternData);
                                content = '';
                                stationId = mGroup[1].trim();
                                if(stationId.includes("'")) {
                                    stationId = stationId.replaceAll("'","");
                                }
                                if(stationId.includes(",")) {
                                    stationId = stationId.replaceAll(",","");
                                }
                                if (stationId === '' && !importStationId) {
                                    await sucsessData(fileSizeErrorStatus, filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                                } else if (stationId === '' && importStationId) {
                                    await sucsessData('Queued', filename, importStationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                                } else if (stationId !== '' && importStationId && stationId !== importStationId) {
                                    await sucsessData('Warning', filename, importStationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                                } else if (stationId !== '' && importStationId && stationId == importStationId) {
                                    await sucsessData('Queued', filename, importStationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                                } else {
                                    await sucsessData('Queued', filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                                }
    
                                // if (stationId === '') {
                                //   await sucsessData(fileSizeErrorStatus, filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                                // }
                                // else {
                                //   await sucsessData('Queued', filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                                // }
    
    
                                break;
                                } else {
                                if (i == fileListData.length - 1) {
                                    content = '';
                                    if (importStationId) {
                                    await sucsessData('Queued', acceptedFiles[j].name, importStationId, '', 'File Storage', 5, acceptedFiles[j], fileExe, 'error');
                                    }
                                    else {
                                    await unSucsessData(fileSizeErrorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'error');
                                    }
                                    break;
                                }
                                }
                            } catch (e) {
                                continue;
                            }
                            } else {
                            if (i == fileListData.length - 1) {
                                content = '';
                                if (importStationId) {
                                await sucsessData('Queued', acceptedFiles[j].name, importStationId, '', 'File Storage', 5, acceptedFiles[j], fileExe, 'error');
                                } else {
                                await unSucsessData(fileSizeErrorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'error');
                                }
                                break;
                            }
                            }
                        }
                        // This code use for match file data using Regex              
                        };
                        reader.readAsText(fileData[j], "UTF-8");
                    }
                    }
                } else {
                    if (getFileStorage > 0) {
                    if (droppedFileSize <= getFileStorage) {
                        if (importStationId) {
                        await sucsessData('Queued', acceptedFiles[j].name, importStationId, '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                        } else {
                        await unSucsessData(errorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                        }
                    } else {
                        await unSucsessData(fileSizeErrorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'error');
                    }
                    }
                }
            }
        }
        let time = new Date - start;
        setTimeout(function () {
            props.setLoaderShow('none');
            props.setShowimportData('block');
        }, time + 500);
        setTimeout(function () {
            history.push('/UsersDashboard');
        }, time + sleeptime);
        // This Conition check files length         
    }
    /* This Function is used for Drag and Drop File end */

    const getFileSize = () => {
        try {
          axios({
            method: 'get',
            url: API_URL + API_PATH.getFileSize,
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                if (response.data && response.data.data) {
                  let fileSizeData = response.data.data;
    
                  let fileStorage = getFileFromArray(fileSizeData, "file_storage")
                  let fS = fileStorage.file_size;
                  setFileStorage(fS);
    
                  let cloudStorage = getFileFromArray(fileSizeData, "cloud_storage")
                  let cs = cloudStorage.file_size;
                  setCloudStorage(cs);
                } else {
                  setFileStorage(0);
                  setCloudStorage(0);
                }
              }
            }).catch(async function (error) {
              setFileStorage(0);
              setCloudStorage(0);
              if (error.response) {
                if (error.response.status && error.response.status == '401') {
                  if (Cookies.get('email')) {
                    clearCookie('email');
                    clearCookie('payload');
                    clearCookie('idToken');
                    clearCookie('atexpiry');
                  }
                  history.push('/');
                }
              }
            })
        } catch (error) {
          setFileStorage(0);
          setCloudStorage(0);
          console.error(error);
        }
    }

    //This code is use for get the pattern for file reading ... start
    let fileTypeData;
    let fileArray = [];
    const getFileList = () => {
        try {
        axios({
            method: 'get',
            url: API_URL + API_PATH.fileTypeList,
        })
            .then(async function (response) {
            if (response.status && response.status == '200') {
                fileTypeData = response.data;
                fileTypeData = fileTypeData.data;
                for (let i = 0; i < fileTypeData.length; i++) {
                let fid = fileTypeData[i].file_type_id;
                let desc = fileTypeData[i].description ? fileTypeData[i].description : '';
                let patt = fileTypeData[i].pattern;
                let ven = fileTypeData[i].vendor ? fileTypeData[i].vendor : '';

                fileArray.push({ file_type_id: fid, pattern: patt, vendor: ven, data_type: desc });
                setFileListData([...fileListData, ...fileArray]);
                }

            } else {
                console.log("Do Not Get Any Station");
            }
            }).catch(async function (error) {
            if (error.response) {
                if (error.response.status && error.response.status == '401') {
                if (Cookies.get('email')) {
                    clearCookie('email');
                    clearCookie('payload');
                    clearCookie('idToken');
                    clearCookie('atexpiry');
                }
                history.push('/');
                }
            }
            })
        } catch (error) {
        console.error(error);
        }
    }
    //This code is use for get the pattern for file reading ... end

    let errorStatus = <p className="errorStatus"><span className="statusIcon"><FontAwesomeIcon icon={faExclamationCircle} /></span>Error</p>;
    let warningStatus = <p className="warningStatus"><span className="statusIcon"><FontAwesomeIcon icon={faFlag} /></span>Warning</p>;
    let errorStatusforStation = {description: "This station id does not exist"};
    let fileSizeErrorStatus = {title: "File too large", description: "The file you are trying to upload exceeds our 10mb limit"};
    let susData = [];
    let locData = [];
    // This function Calles Set Table Data if status Queued        
    const sucsessData = (status, fileName, stationId, vendor, dataType, file_type_id, fileBody, fileExe, file_size_status) => {
        let importStationId = props.importStationId;
        let statusCheck = errorStatus;
        let fileStatus = 'error';
        let station_id = 0;
        if (stationId !== '') {
        statusCheck = errorStatusforStation;
        }

        if(props.stationDetails.length === 0 ) {
            props.changeMapView([...props.mapLocation]);
        }
        if (importStationId) {
            props.stationDetails.map((sid, index) => {
                statusCheck = status;
                if (importStationId === sid.stationId) {
                    station_id = sid.station_id;
                }
                if (file_size_status === 'success') {
                    fileStatus = 'success';
                } else if (file_size_status === 'warning') {
                    statusCheck = warningStatus;
                    fileStatus = 'success';
                } else {
                    statusCheck = fileSizeErrorStatus;
                }
                if (stationId === sid.stationId) {
                    locData.push({ clent_Station_id: stationId });
                    props.setMapLocation([...props.mapLocation, ...locData]);
                    let tempData = [...props.mapLocation, ...locData];
                    props.changeMapView(tempData);
                }
            });
        } else {
            props.stationDetails.map((sid, index) => {
                if (stationId === sid.stationId) {
                    statusCheck = status;
                    station_id = sid.station_id;
                    if (file_size_status === 'success') {
                        fileStatus = 'success';
                    }
                    else {
                        statusCheck = fileSizeErrorStatus;
                    }
                    locData.push({ clent_Station_id: stationId });
                    props.setMapLocation([...props.mapLocation, ...locData]);
                    let tempData = [...props.mapLocation, ...locData];
                    props.changeMapView(tempData);
                }
            });
        }

        let uniqueID = new Date().valueOf();
        let tmp_status_id = dataType === 'File Storage' ? 2 : 0;
        susData.push({ uniqueID: uniqueID, station_id: station_id, status: statusCheck, fileName: fileName, sationId: stationId, dataType: dataType, vendor: vendor, file_status: fileStatus, file_type_id: file_type_id, file_body: fileBody, file_exe: fileExe, file_size_status: file_size_status, import_Status: 'ready', file_status_id: tmp_status_id, progress: 0 });
        props.setDetails([...props.details, ...susData]);
    }
    // This function Calles Set Table Data if status Queued

    // This function Calles Set Table Data if status Error
    const unSucsessData = (status, fileName, stationId, vendor, dataType, file_type_id, fileBody, fileExe, file_size_status) => {
        props.changeMapView([...props.mapLocation]);
        let uniqueID = new Date().valueOf();
        susData.push({ uniqueID: uniqueID, station_id: 0, status: status, fileName: fileName, sationId: '', dataType: dataType, vendor: vendor, file_status: 'error', file_type_id: file_type_id, file_body: fileBody, file_exe: fileExe, file_size_status: file_size_status, import_Status: 'ready', file_status_id: 2, progress: 0 });
        props.setDetails([...props.details, ...susData]);
    }
    // This function Calles Set Table Data if status Error

    function getFileFromArray(fileArray, fileExt) {
        let temp = fileArray.find((fileEle, index) =>
          (fileEle.file_type.trim() === fileExt ||
            fileEle.file_type.trim() === fileExt.toString().toUpperCase())
        )
        return temp;
    }

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <div>
            <Collapse in={props.checkedImport}>
                <Paper elevation={4} style={{ margin: '0px' }}>
                    <CssBaseline />
                    <div className="import-main-panel">
                        <Container maxWidth="sm" className="import-container" data-testid='dragFileModal'>
                            <AppBar position="static" color="default" className="tabs-header">
                                <Tabs
                                value={tabValue}
                                onChange={handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                                aria-label="full width tabs example"
                                >
                                    <Tab label="Import Data" {...a11yProps(0)} id="import_tab" data-testid="allTab" />
                                    <Tab label="Templates" id="templates_tab" data-testid="allTab" />
                                </Tabs>
                                <div>
                                    <NavLink to='/UsersDashboard'><img src={require('../../../assets/icons/close.svg')}  /></NavLink>
                                </div>
                            </AppBar>
                            <SwipeableViews
                                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                index={tabValue}
                                onChangeIndex={handleChangeTab}
                            >
                                <TabPanel value={tabValue} index={0} dir={theme.direction} >
                                <div>
                                    <div className='info-tag'>
                                        <FontAwesomeIcon icon={faInfoCircle} />
                                        <span>File import requirements and best practices</span>
                                        <div>
                                            <a href="https://intercom.help/DataPointApp/en/collections/3288501-import-data" target="_blank" className="infoText">Details</a>
                                            <ArrowForwardIcon />
                                        </div>
                                    </div>
                                    <div className="drag-upload-section" onMouseEnter={() => setHoverActive(true)} onMouseLeave={() => setHoverActive(false)}>
                                        <Dropzone
                                        onDrop={handleDrop}
                                        multiple={true}>
                                        {({ getRootProps, getInputProps }) => (
                                            <div {...getRootProps({ className: "dropzone" })}>
                                            <input {...getInputProps()} />
                                            <div className="upload-content">
                                                {
                                                    hoverActive ?
                                                    <img src={require('../../../assets/icons/upload-files-blue.png')} />
                                                    :
                                                    <img src={require('../../../assets/icons/upload-files.png')} />
                                                }
                                                <span>Upload files</span>
                                                <p>Drag or press in the square to select and upload your files</p>
                                                {props.details.length >= API_PATH.fileUploadLimit ?
                                                <p style={{ textAlign: 'center', margin: '10px 0 0 0', fontSize: '16pt', color: '#CC0000', display: props.fileCountData }}>Limit Exceeded !</p>
                                                : null}
                                            </div>
                                            </div>
                                        )}
                                        </Dropzone>
                                    </div>
                                </div>
                                </TabPanel>
                                <TabPanel value={tabValue} index={1} dir={theme.direction}>
                                    <ImportTemplates />
                                </TabPanel>
                            </SwipeableViews>
                        </Container>
                    </div>
                </Paper>
            </Collapse>
        </div>
    )
}

export default ImportPanel;